import React from "react";
import { Section } from "@/layout/Section";
import { useT } from "@/hooks/useT";
import { SimplePage } from "@/layout/SimplePage";
import loginClip from "../../assets/cliparts/login.svg";
import { LinkSignupForm } from "./LinkSignupForm";
import { Grid } from "@mui/material";

interface SignupTemplateProps {
  children: React.ReactNode;
}

export const SignupTemplate: React.FC<SignupTemplateProps> = ({ children }) => {
  const { t } = useT();

  return (
    <SimplePage>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Section title={t("page.signup.title")}>
            <p>{t("page.signup.description")}</p>
          </Section>
        </Grid>
        <Grid item xs={12} md={6} />
        <Grid item xs={12} sx={{ mt: 6 }} />
        <Grid item xs={12} md={6}>
          {children}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: {
              xs: "none",
              md: "block",
            },
          }}
        >
          <img
            src={loginClip}
            alt={"Signup Clipart"}
            style={{ maxWidth: "100%" }}
          />
        </Grid>
      </Grid>
    </SimplePage>
  );
};

export const Signup: React.FC = () => {
  const { t } = useT();
  return (
    <SignupTemplate>
      <LinkSignupForm />
    </SignupTemplate>
  );
};
